export const energyPlansConstants={
    ENERGY_PLANS_DETAILS_SUCCESS:"ENERGY_PLANS_DETAILS_SUCCESS",
    ENERGY_PLAN_TO_COMPARE_SUCCESS:"ENERGY_PLAN_TO_COMPARE_SUCCESS",
    ENERGY_PLANS_DETAILS_ERROR:"ENERGY_PLANS_DETAILS_ERROR",
    UPDATE_ENERGY_PLANS_DETAILS:"UPDATE_ENERGY_PLANS_DETAILS",
  }